/**
 * Where the leading "back" control on a screen stacked above the app shell
 * should go.
 *
 * The settings group is a formSheet; a sub-screen (e.g. AI & Memory) is normally
 * reached from the settings index, so the chevron pops back. But those screens
 * are also deep-linked directly (the sidebar/web links straight to
 * /settings/memory), leaving no back history, in that case the chevron must
 * fall back to the app root instead of doing nothing (issue #290).
 *
 * Notifications and Messages have the same shape: normally pushed from the
 * drawer, but also opened cold from a push notification, where there may be
 * nothing to pop.
 */
export type SheetBackTarget =
  | { action: 'back' }
  | { action: 'replace'; href: string };

export function resolveSheetBackTarget(
  canGoBack: boolean,
  fallbackHref = '/',
): SheetBackTarget {
  return canGoBack ? { action: 'back' } : { action: 'replace', href: fallbackHref };
}
